/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const taxRateDataSchema = z.object({
	percentage: z.number(),
	displayName: z.string(),
})

export type TaxRateDataSchema = z.infer<typeof taxRateDataSchema>
